import { BillingMetrics } from '../../../shared/BillingMetrics';

interface BotMetricConsumption {
  metricId: string;
  total: number;
}

interface AiTokenBotConsumptionRaw {
  botName: string;
  metricConsumption: BotMetricConsumption[];
}

export class AiTokenBotConsumption {
  botName!: string;
  aiToken!: number;

  constructor(raw: AiTokenBotConsumptionRaw) {
    this.botName = raw.botName;
    this.aiToken = raw.metricConsumption.find((mc) => mc.metricId === BillingMetrics.aiToken)?.total ?? 0;
  }
}
